import axios from 'axios'

const { LEADS_API } = process.env

const apileads = axios.create({
  baseURL: LEADS_API,
  withCredentials: true,
  timeout: 600000,
  headers: {
    'Content-Type': 'application/json',
    // 'Authorization': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzUxMiJ9.eyJQIjp7IjQ2Ijo0LCI0NyI6NCwiMzciOjQsIjM4IjoxLCIyOCI6MSwiMzIiOjF9LCJpc3MiOiJtb2JpbGl0eSIsImV4cCI6MTc0MTIyODM5OCwidXVpZCI6ImUyZDFkMWMyLWU3YTAtNDE0Mi04ZDNkLWUyYTYwMWU5NGEzOCIsImlhdCI6MTc0MTE5OTU5OH0.M4V8Fbq7VosEQf234XQW0JkVqS0M5HxKMidoPmOWx9Milhg3eNdjy0dXxpawKYrsl8ZrH9ptle90yMuOsWy0E5sBYxJBGVSP7Z24-Ci-c02bCu3VXU8_4c2Sc0ikNBmGfuIrBFRrsU2YUlfgA_RvFgf41d1OVVKewNfuxajYJcKhpcHuXpuvoZe2oo7fl9YVgv8_bUAJiybGhwqH9jQYoa1kJy_MyOYNF60_Hvl9dHYg7vq3TAO4sIWCuqV1w2mVnr6IFC5ni1Q2qBnjJaEjvKloTk4AGWEk5wtnmcse3p76NzDadiHW_7flj11Yrd0kY8aYmNFtOAll8sUST6YWV6zHmFpFiXA6CRuofgrIPUQFHAmlpAELz1T7gX9PD7BO-s6Rn8ujTAn7vG9-d3UFXVTIaJKCYY5eDnhjxs2Y6b3G6qtDz7uIeWdXkn-HLMdez3-J-L1SSf_KWr9CGPzK-8TTfcLaE0qHgJjywFnR8RRw9Ng7ZEEOby2VtWEzCmlR72eajruFg1CCsn-VE6myyVdydCNwXY_wdnKQG51pplkk9_WGnkJyQQmyFwTl-uXqScfOIeJga5TAy7-eUVPnOKMt1XPbyNf6T7TGimMEq4LjSv-wP7AeBARm229NXMAOrLPmABN1fVJkX-ovU-2FHJCVC8yf_UVdlbTmo4efqC0',
  },
})

// apileads.interceptors.response.use(
//   response => {
//     const loginPage = window.location.pathname.indexOf('/') !== -1
//     if (response.status === 403 && loginPage) {
//       sessionStorage.setItem('userStatus', '')
//       window.location.href = '/'
//     }
//     return response
//   },
//   error => {
//     const loginPage = window.location.pathname.indexOf('/') !== -1
//     if (error.response.status === 403 && loginPage) {
//       sessionStorage.setItem('userStatus', '')
//       window.location.href = '/'
//     }
//     if (error.response.status === 500 && process.env.NODE_ENV !== 'development') {
//       sessionStorage.setItem('userStatus', '')
//       window.location.href = '/'
//     }
//     return Promise.reject(error)
//   }
// )

export { apileads }
